/* tslint:disable */

/* eslint-disable */

/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists, mapValues } from "../runtime";
import {
  LogFormat,
  LogFormatFromJSON,
  LogFormatFromJSONTyped,
  LogFormatToJSON,
} from "./LogFormat";
import {
  ProcessStatus,
  ProcessStatusFromJSON,
  ProcessStatusFromJSONTyped,
  ProcessStatusToJSON,
} from "./ProcessStatus";

/**
 *
 * @export
 * @interface Ingestion
 */
export interface Ingestion {
  /**
   *
   * @type {string}
   * @memberof Ingestion
   */
  id: string;
  /**
   *
   * @type {Date}
   * @memberof Ingestion
   */
  createdAt: Date;
  /**
   *
   * @type {Date}
   * @memberof Ingestion
   */
  updatedAt: Date | null;
  /**
   *
   * @type {Date}
   * @memberof Ingestion
   */
  deletedAt: Date | null;
  /**
   *
   * @type {string}
   * @memberof Ingestion
   */
  createdBy: string | null;
  /**
   *
   * @type {string}
   * @memberof Ingestion
   */
  updatedBy: string | null;
  /**
   *
   * @type {string}
   * @memberof Ingestion
   */
  deletedBy: string | null;
  /**
   *
   * @type {string}
   * @memberof Ingestion
   */
  logId: string;
  /**
   *
   * @type {ProcessStatus}
   * @memberof Ingestion
   */
  status: ProcessStatus;
  /**
   *
   * @type {boolean}
   * @memberof Ingestion
   */
  processing: boolean;
  /**
   *
   * @type {boolean}
   * @memberof Ingestion
   */
  queued: boolean;
  /**
   *
   * @type {boolean}
   * @memberof Ingestion
   */
  cancelled: boolean;
  /**
   *
   * @type {boolean}
   * @memberof Ingestion
   */
  errored: boolean;
  /**
   *
   * @type {boolean}
   * @memberof Ingestion
   */
  archived: boolean;
  /**
   *
   * @type {boolean}
   * @memberof Ingestion
   */
  completed: boolean;
  /**
   *
   * @type {string}
   * @memberof Ingestion
   */
  name: string | null;
  /**
   *
   * @type {LogFormat}
   * @memberof Ingestion
   */
  format: LogFormat | null;
  /**
   *
   * @type {string}
   * @memberof Ingestion
   */
  s3Bucket: string | null;
  /**
   *
   * @type {string}
   * @memberof Ingestion
   */
  s3Key: string | null;
  /**
   *
   * @type {number}
   * @memberof Ingestion
   */
  size: number | null;
  /**
   *
   * @type {number}
   * @memberof Ingestion
   */
  progress: number | null;
  /**
   *
   * @type {object}
   * @memberof Ingestion
   */
  error: object | null;
  /**
   *
   * @type {string}
   * @memberof Ingestion
   */
  note: string | null;
  /**
   *
   * @type {number}
   * @memberof Ingestion
   */
  startOffset: number | null;
  /**
   *
   * @type {number}
   * @memberof Ingestion
   */
  endOffset: number | null;
  /**
   *
   * @type {object}
   * @memberof Ingestion
   */
  meta: object | null;
  /**
   *
   * @type {object}
   * @memberof Ingestion
   */
  context: object | null;
}

export function IngestionFromJSON(json: any): Ingestion {
  return IngestionFromJSONTyped(json, false);
}

export function IngestionFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): Ingestion {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    id: json["id"],
    createdAt: new Date(json["created_at"]),
    updatedAt:
      json["updated_at"] === null ? null : new Date(json["updated_at"]),
    deletedAt:
      json["deleted_at"] === null ? null : new Date(json["deleted_at"]),
    createdBy: json["created_by"],
    updatedBy: json["updated_by"],
    deletedBy: json["deleted_by"],
    logId: json["log_id"],
    status: ProcessStatusFromJSON(json["status"]),
    processing: json["processing"],
    queued: json["queued"],
    cancelled: json["cancelled"],
    errored: json["errored"],
    archived: json["archived"],
    completed: json["completed"],
    name: json["name"],
    format: LogFormatFromJSON(json["format"]),
    s3Bucket: json["s3_bucket"],
    s3Key: json["s3_key"],
    size: json["size"],
    progress: json["progress"],
    error: json["error"],
    note: json["note"],
    startOffset: json["start_offset"],
    endOffset: json["end_offset"],
    meta: json["meta"],
    context: json["context"],
  };
}

export function IngestionToJSON(value?: Ingestion | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    id: value.id,
    created_at: value.createdAt.toISOString(),
    updated_at: value.updatedAt === null ? null : value.updatedAt.toISOString(),
    deleted_at: value.deletedAt === null ? null : value.deletedAt.toISOString(),
    created_by: value.createdBy,
    updated_by: value.updatedBy,
    deleted_by: value.deletedBy,
    log_id: value.logId,
    status: ProcessStatusToJSON(value.status),
    processing: value.processing,
    queued: value.queued,
    cancelled: value.cancelled,
    errored: value.errored,
    archived: value.archived,
    completed: value.completed,
    name: value.name,
    format: LogFormatToJSON(value.format),
    s3_bucket: value.s3Bucket,
    s3_key: value.s3Key,
    size: value.size,
    progress: value.progress,
    error: value.error,
    note: value.note,
    start_offset: value.startOffset,
    end_offset: value.endOffset,
    meta: value.meta,
    context: value.context,
  };
}
